module.exports = __webpack_public_path__ + "media/reskin-images/icon--user-bbde5192.svg";